(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
    const outerSwiper = document.querySelector('.swiper.out');
    const outSwiper =  new Swiper('.swiper.out',{
          navigation: {
            nextEl: '.out-swiper.hdt-slider__button--next',
            prevEl: '.out-swiper.hdt-slider__button--prev',
          },
          disabledClass: 'disabled',
    })
    
const innerSwiperElements = document.querySelectorAll('.swiper.inner:not(.break)');
innerSwiperElements.forEach(swiperElement => {
  const innerSwiper = new Swiper(swiperElement, {
    nested: true,
    resistanceRatio: 0,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    on: {
      slideChangeTransitionEnd: function() {
  
        const swiperId = this.el.id;
        const activeIndex = this.realIndex + 1; 

        console.log('activeIndex:'+activeIndex)
        console.log("swiperId:", swiperId);
        const currentId = swiperId.split('-')[0]; // 修复拼写错误
        console.log("currentId:", currentId);

        // 精准匹配按钮（确保 value 格式为 "swiperId-number"）
        const relatedButtons = document.querySelectorAll(
          `.hdt-lp-pin_item[value^="${currentId}-"]`
        );

        relatedButtons.forEach(button => {
          const buttonIndex = button.getAttribute('value').split('-')[1];
          button.setAttribute(
            'aria-current',
            buttonIndex === String(activeIndex) ? 'true' : 'false'
          );
        });
      },
    },
  });
});


  document.querySelectorAll('.swiper .hdt-lp-pin_item').forEach(function (pin) {
    const value = pin.getAttribute('value')
  
    const swiperId = value.split('-')[0] + '-inner';
    const swiperLoopItem = value.split('-')[1];
  
    pin.addEventListener('click', function () {
      pin.parentElement.querySelectorAll('.hdt-lp-pin_item').forEach((item)=>{
         item.setAttribute('aria-current', 'false');
      })
       pin.setAttribute('aria-current', 'true');

      var selectSwiper = document.getElementById(swiperId);
      selectSwiper.swiper.slideToLoop(swiperLoopItem - 1, 500, false);
    });

    
  });

  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-image-with-text"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.blog-list').forEach(bloglist => {
  const data = bloglist.getAttribute('data-items');
  let items = [];

  try {
    items = JSON.parse(data);
  } catch (e) {
    console.error('Invalid JSON:', e);
    return;
  }

  items.forEach(item => {
    const bannerWrapper = document.createElement('div');
    bannerWrapper.classList.add('banner-wrapper');

    const imagelink = document.createElement('a');
    imagelink.classList.add('banner-image');
    imagelink.href = item.buttons?.[0]?.url || '#'; 

    const image = document.createElement('img');
    image.src = item.image;
    imagelink.appendChild(image);
    bannerWrapper.appendChild(imagelink);

    const buttonWrapper = document.createElement('div');
    buttonWrapper.classList.add('button-wrapper');

    item.buttons?.forEach(buttonData => {
      if (!buttonData.url || buttonData.url.trim() === '') {
        return; // 跳过没有链接的按钮
      }

      const button = document.createElement('a');
      button.classList.add(
        ...'hdt-btn hdt-text-xl hdt-oh hdt-inline-flex hdt-align-center hdt-justify-center hdt-relative hdt-btn-solid hdt-font-medium'.split(' ')
      );
      button.href = buttonData.url;
      button.innerText = buttonData.title;
      buttonWrapper.appendChild(button);
    });

    bannerWrapper.appendChild(buttonWrapper);
    bloglist.appendChild(bannerWrapper);
  });
});

  } catch(e) { console.error(e); }
})();
})();
